import { useEffect, useState } from "react";
import { getHighlights } from "services";
import { GetAllResponse } from "types/getAllResponse";
import { Highlight } from "types/highlights";

export const useHighlights = () => {
  const [highlights, setHighlights] = useState<GetAllResponse<Highlight>>();

  useEffect(() => {
    Promise.all([getHighlights()]).then(([{ data: highlights }]) => {
      setHighlights(highlights);
    });
  }, []);

  return { highlights };
};
